(function () {
  var SECTION_ID = 'cart-drawer';
  function getDrawer() { return document.getElementById('cart-drawer'); }
  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.documentElement.classList.add('cart-drawer-open');
  }
  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cart-drawer-open');
  }
  function renderDrawer(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newDrawer = doc.getElementById('cart-drawer');
    var oldDrawer = getDrawer();
    if (newDrawer && oldDrawer) { oldDrawer.replaceWith(newDrawer); }
    updateCartCount();
  }
  function updateCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    });
  }
  function addToCart(formData) {
    formData.append('sections', SECTION_ID);
    formData.append('sections_url', window.location.pathname);
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData })
      .then(function (response) {
        if (!response.ok) { return response.json().then(function (err) { throw err; }); }
        return response.json();
      })
      .then(function (data) {
        if (data.sections && data.sections[SECTION_ID]) { renderDrawer(data.sections[SECTION_ID]); }
        openDrawer();
        return data;
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
        alert(err && err.description ? err.description : 'Impossible d’ajouter cet article au panier.');
      });
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.getAttribute('action') === null) return;
    if (form.getAttribute('action').indexOf('/cart/add') === -1) return;
    event.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    addToCart(new FormData(form)).finally(function () {
      if (submitBtn) submitBtn.disabled = false;
    });
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-close]')) { closeDrawer(); }
    if (event.target.closest('[data-cart-drawer-toggle]')) { event.preventDefault(); openDrawer(); }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });
})();